<template>
  <div :class="b()">
    <c-text-overlay
      v-if="!!label?.label"
      :label="label"
      variant="label"
      :class="b('label')"
    />

    <c-product-image-gallery
      v-if="showAsGallery && images.length"
      :class="b('gallery')"
      :images="images || []"
      use-lightbox
      use-thumbs
    >
      <c-text-overlay
        v-if="textImageOverlay"
        :text="textImageOverlay"
      />
    </c-product-image-gallery>

    <template v-else>
      <c-text-overlay
        v-if="textImageOverlay"
        :text="textImageOverlay"
      />

      <e-picture
        v-if="image"
        :srcset="image.srcset"
        :alt="image?.alt || image?.title || $t('c-product-image.alt-text')"
        :title="image.title"
        :fallback="image.fallback"
        :ratio="1"
        :sizes="pictureSizes"
        :placeholder="!image"
        loading="lazy"
        :class="b('image')"
      />

      <div
        v-else
        :class="b('image-fallback')"
      >
        <span style="display: none">No image available</span>
      </div>
    </template>
  </div>
</template>

<script lang="ts">
  import { PropType, defineComponent } from 'vue';
  import { PRODUCT_DISPLAY_PICTURE_SIZES } from '@/setup/globals';
  import cProductImageGallery from '@/components/c-product-image-gallery.vue';
  import cTextOverlay from '@/components/c-text-overlay.vue';
  import ePicture from '@/elements/e-picture.vue';
  import { Image } from '@/types/image';
  import { TextLabel } from '@/types/product';
  import { ImageSizes } from '@/types/sizes';

  // type Setup = {};
  // type Data = {};

  /**
   * Shows a product image.
   */
  export default defineComponent({
    name: 'c-product-image',
    components: {
      cTextOverlay,
      ePicture,
      cProductImageGallery,
    },

    // components: {},

    props: {
      /**
       * The images to show.
       */
      images: {
        type: Array as PropType<Image[]>,
        default: () => [],
      },

      /**
       * Define if the image should be shown as a gallery.
       */
      showAsGallery: {
        type: Boolean,
        default: false,
      },

      /**
       * Define the sizes of the image.
       */
      pictureSizes: {
        type: Object as PropType<ImageSizes>,
        default: PRODUCT_DISPLAY_PICTURE_SIZES,
      },

      /**
       * Define the overlay text.
       */
      textImageOverlay: {
        type: String as PropType<string | null>,
        default: '',
      },

      /**
       * Define the overlay label.
       */
      label: {
        type: Object as PropType<TextLabel | null>,
        default: null,
      },
    },
    // emits: [],

    // setup(): Setup {
    //   return {};
    // },
    // data(): Data {
    //   return {};
    // },

    computed: {
      image(): Image | null {
        return this.images?.[0] || null;
      },
    },
    // watch: {},

    // beforeCreate() {},
    // created() {},
    // beforeMount() {},
    // mounted() {},
    // beforeUpdate() {},
    // updated() {},
    // activated() {},
    // deactivated() {},
    // beforeUnmount() {},
    // unmounted() {},

    // methods: {},
    // render() {},
  });
</script>

<style lang="scss">
  @use '@/setup/scss/mixins';
  @use '@/setup/scss/variables';

  .c-product-image {
    position: relative;

    &__label {
      top: 0.5rem;
      left: 0.5rem;
    }

    &__image-fallback {
      width: 100%;
      aspect-ratio: 1;
      background-color: rgba(var(--theme-color-primary--1-rgb), 0.3);
    }
  }
</style>
